import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {ObjectBaseComponent} from "../../../../../../../core/shared/object/mvs-object-base/object-base.component";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {DtoImportObjectContext} from "../../../../../../../core/shared/dto/dto.import.object.context";
import {DtoDetail} from "../../../../../../../core/shared/dto/dto.detail";
import {ActivatedRoute} from "@angular/router";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {ConfirmationService} from "primeng/api";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../../../core/shared/object/service/observer.service";
import {DtoImportObjectContextEntry} from "../../../../../../../core/shared/dto/dto.import.object.context.entry";
import {ObjectChangeInformation} from "../../../../../../../core/shared/logic/object-change-information";


@Component({
    selector: 'cm-update-insurable-object-object',
    templateUrl: 'cm-update-insurable-object-object.component.html',
    standalone: false
})
export class CmUpdateInsurableObjectObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    objectIdentifier: ObjectIdentifier;
    importObjectContext: DtoImportObjectContext;
    customerId: number;
    insurableObjectId: number;
    defaultCreateDto: DtoDetail;

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor(protected route: ActivatedRoute,
                protected coreService: MvsCoreService,
                protected confirmationService: ConfirmationService,
                protected messageService: MvsMessageService,
                protected override observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit(): void {

        super.ngOnInit();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }


    onObjectChanged() {
        this.createNew();
    }



    createNew() {
        const dto: DtoImportObjectContextEntry = this.importObjectContext.getEntry('cr.Customer');
        if (!dto) {
            return;
        }
        this.customerId = dto.id;
        this.insurableObjectId = this.dto['insurableObjectDtoId'];

    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["objectIdentifier"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
    }

    handleObjectChange(event: ObjectChangeInformation) {
        this.onChangedObject.emit(event);
    }

}

